import { CheckoutPayload } from "../../../core/models/checkout-payload.model";
import { CreditCardModel } from "../../../core/models/credit-card.model";


export class CheckoutCustomTest {
  // CUSTOM CREDIT CARD
  private isValidCustomCardDetails = ko.observable(false);

  constructor(
    private readonly processPayment: (paymentType: string, data: Partial<CheckoutPayload>) => void) {
  }

  public initialise() {
    $('.custom-elements').show(); // TO DO: CONVERT TO KNOCKOUTJS

    const $customCardNumber = $('#custom-card-number')!;
    const $customExpiryDate = $('#custom-expiry-date')!;
    const $customCvv = $('#custom-cvv');

    $customCardNumber.keyup(() => {
        const creditCardRegEx = /\d{4}-?\d{4}-?\d{4}-?\d{4}/i;
        const amexRegEx = /^3[47]\d{13,14}$/i;
        if (creditCardRegEx.test($customCardNumber.val().toString()) || amexRegEx.test($customCardNumber.val().toString())) $customCardNumber.addClass('valid'); else $customCardNumber.removeClass('valid');
        this.CheckTestFormValidation();
    });
    $customExpiryDate.keyup(() => {
        const expiryDateRegEx = /^\d{2}\/\d{2}$/i;
        if (expiryDateRegEx.test($customExpiryDate.val().toString())) $customExpiryDate.addClass('valid'); else $customExpiryDate.removeClass('valid');
        this.CheckTestFormValidation();
    });
    $customCvv.keyup(() => {
        const cvvRegEx = /^([0-9]{3,4})$/i;
        if (cvvRegEx.test($customCvv.val().toString())) $customCvv.addClass('valid'); else $customCvv.removeClass('valid');
        this.CheckTestFormValidation();
    });
  }

    //Validation for Test Gateway
    private CheckTestFormValidation() {
        const isCustomCardValid = $('#custom-card-number').hasClass('valid');
        const isCustomExpiryDateValid = $('#custom-expiry-date').hasClass('valid');
        const isCvvValid = $('#custom-cvv').hasClass('valid');
        if (isCustomCardValid && isCustomExpiryDateValid && isCvvValid) {
            this.isValidCustomCardDetails(true);
        } else {
            this.isValidCustomCardDetails(false);
        }
    }
    
    public payment() {
      if (!this.isValidCustomCardDetails()) {
        return;
      }

      const creditCard: CreditCardModel = {
        cardBrand: this.getCardBrand(),
        cardToken: 'custom',
        cardCountry: 'AU'
      };

      this.processPayment(creditCard.cardBrand, {
        creditCard,
        customCardNumber: $('#custom-card-number').val() as string
      });
  }

  private getCardBrand(): string {
    switch ($('#custom-card-number').val()?.toString().charAt(0)) {
      case '3': return 'amex';
      case '4': return 'visa';
      case '5': return 'mastercard';
      default: return 'visa';
    }
  }
}